<template>
    <div class="w-full">
        <PageHeader title="Playlists">
            <template #meta>{{ playlists?.total ? playlists.total + ' collections' : 'Curated collections of songs' }}</template>
        </PageHeader>

        <div v-if="playlists?.data?.length" class="-mx-2.5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            <MediaCard v-for="playlist in playlists.data" :key="playlist.id" :href="'/playlist/' + playlist.id"
                :image="playlist.cover" :title="playlist.name"
                :subtitle="(playlist.songs_count ?? 0) + (playlist.songs_count === 1 ? ' song' : ' songs')" />
        </div>
        <p v-else class="py-16 text-center text-nomad-400">No playlists yet.</p>

        <nav v-if="playlists?.prev_page_url || playlists?.next_page_url" class="mt-8 flex items-center justify-between gap-3" aria-label="Pagination">
            <Link v-if="playlists.prev_page_url" :href="playlists.prev_page_url" class="nl-btn-ghost">
                <span class="icon-chevron-left" aria-hidden="true"></span> Previous
            </Link>
            <span v-else></span>
            <Link v-if="playlists.next_page_url" :href="playlists.next_page_url" class="nl-btn-ghost">
                Next <span class="icon-chevron-right" aria-hidden="true"></span>
            </Link>
        </nav>
    </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import MediaCard from "@/components/ui/MediaCard.vue";
defineProps({ playlists: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { mapState, mapActions } from "vuex";
import { usePage, Link } from "@inertiajs/vue3";

export default {
    methods: {
        ...mapActions("playlists", ["getAllPlaylist"]),
    },
    beforeMount() {
        document.title = 'Playlists - Music Collection'
    },
    components: {
        Link,
    }
};
</script>
